import React from 'react';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import Button from '@dealroadshow/uikit-button';
import SharedCustomers from '@framework/ui/Pages/Landing/Sections/Customers';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import customers from './constants';

import styles from './customers.module.scss';

const Customers = () => (
  <Section padding="top">
    <SectionContainer size="large">
      <SectionHeader
        title="Hundreds of leading corporations switched to DealVDR"
        description="The switch is easy. We understand your process and operate at a higher standard than legacy providers. "
        className={ styles.headerWrapper }
      />
      <SharedCustomers
        customers={ customers }
        showMoreButton={ (buttonProps) => (
          <NextNavLink
            to="/customers"
            dataTest="exploreOurCustomers"
          >
            <Button
              { ...buttonProps }
              title="Explore Our Customers"
              dataTest="exploreOurCustomersButton"
            />
          </NextNavLink>
        ) }
      />
    </SectionContainer>
  </Section>
);

export default Customers;
